export function Spinner({ label, small }: { label?: string; small?: boolean }) {
  const size = small ? "h-4 w-4" : "h-5 w-5";
  return (
    <div className="flex items-center gap-2 text-zinc-500">
      <svg className={`${size} animate-spin`} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
        <path className="opacity-90" fill="currentColor" d="M12 2a10 10 0 0 1 10 10h-3a7 7 0 0 0-7-7V2Z" />
      </svg>
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}
